import { api } from './api'

/**
 * The two-question onboarding (V3-b): the «نمی‌دانم» samples to listen to
 * before signing in, and the two answers once there is a session.
 */

/**
 * `onboarding_samples` — public, like `countries_list`. Always all three
 * levels in beginner → intermediate → advanced order, up to three samples
 * each (`position`, absolute public `audioUrl`, `textEn`, `durationMs`),
 * plus `minuteOptions`, the only values `completeOnboarding` accepts.
 */
export async function onboardingSamples() {
  const { data } = await api.get('/onboarding/samples')
  return data
}

/**
 * `onboarding_complete` — bearer. `{ level, dailyMinutes }` →
 * `{ level, dailyMinutes, onboardedAt }`; 422 `invalid_daily_minutes` for a
 * value outside `minuteOptions`. Calling it again overwrites the answers.
 */
export async function completeOnboarding({ level, dailyMinutes }) {
  const { data } = await api.post('/onboarding/complete', { level, dailyMinutes })
  return data
}
